var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"no-print button-box-element",on:{"click":_vm.generatePDF}},[_vm._v(_vm._s(_vm.t('download_pdf'))+" "),_c('chill-icon',{staticClass:"dark new-tab-one-icon",attrs:{"size":"small-icon","icon":"arrow_down_filled"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }